module.exports = __webpack_public_path__ + "img/4_การแจ้งซ้อม.d8f62ed6.png";